module.exports = __webpack_public_path__ + "static/img/view-report.d6f13987.svg";